export const API = {
  getData: (fun, from, to) => `/query?function=${fun}&from_currency=${from}&to_currency=${to}&apikey=G8TGVEMITLM8CTFN`,
  getSMA: (func, first, second, interval, time) => `/query?function=${func}&symbol=${first}${second}&interval=${interval}&time_period=${time}&series_type=open&apikey=G8TGVEMITLM8CTFN`,
};
